import { fetchApi } from 'common/api/fetchApi'

import { paths } from './generated/gdpr'

type General = paths['/gdpr/status']
type Get = General['get']
type Result = Get['responses']['200']['schema']

export const fetchGdprStatusApi = () => fetchApi<Result>('/gdpr/status')
